import { breakpoints } from '@bnnvara/breakpoints';
import { ThemeIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Theme';
import { Text } from '@bnnvara/typography';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { typography, space } from 'styled-system';

const getColor = (theme, themeSlug, gradient = 'main') => {
  const color = theme?.themes[themeSlug?.replace('-', '_')][gradient];

  if (color) return color;
  return theme.base.white;
};

const Small = css`
  div {
    font-size: 14px;
  }
  svg {
    height: 9px;
    width: 9px;
  }
`;

const StyledThemeTagArticle = styled.span`
  display: inline-flex;
  align-items: center;
  text-transform: Capitalize;
  cursor: pointer;
  div {
    color: ${({ theme, themeSlug }) => getColor(theme, themeSlug)};
    text-decoration: underline;
    text-decoration-thickness: from-font;
    margin-top: -1px;
  }
  &:hover {
    div {
      color: ${({ theme, themeSlug }) => getColor(theme, themeSlug, 'dark')};
    }
    svg {
      * {
        fill: ${({ theme, themeSlug }) => getColor(theme, themeSlug, 'dark')};
      }
    }
  }
  &:active {
    div {
      color: ${({ theme, themeSlug }) => getColor(theme, themeSlug, 'light')};
    }
    svg {
      * {
        fill: ${({ theme, themeSlug }) => getColor(theme, themeSlug, 'light')};
      }
    }
  }

  ${breakpoints.md} {
    padding: 4px 0px;
    border-radius: 2px;
  }

  svg {
    height: 9px;
    width: 9px;
    padding-right: 4px;
    * {
      fill: ${({ theme, themeSlug }) => getColor(theme, themeSlug)};
    }
    ${breakpoints.md} {
      margin-top: 1px;
      height: 14px;
      width: 14px;
    }
  }

  ${({ size }) => size === 'sm' && Small};
  ${space}
  ${typography}
`;

export const ThemeTagArticle = ({
  children,
  themeSlug,
  size,
  href,
  ...props
}) => {
  return (
    <Link href={href}>
      <StyledThemeTagArticle themeSlug={themeSlug} size={size} {...props}>
        <ThemeIcon />
        <Text>{children}</Text>
      </StyledThemeTagArticle>
    </Link>
  );
};

ThemeTagArticle.defaultProps = {
  size: 'md',
};

ThemeTagArticle.propTypes = {
  children: PropTypes.node.isRequired,
  iconLeft: PropTypes.node,
  themeSlug: PropTypes.string,
  href: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
};
